import { computeAccommodationOfferTotalsView } from 'checkout/lib/utils/accommodation/priceView'
import { addTotals } from 'checkout/lib/utils/payments/totals'
import { createSelector } from 'reselect'
import { sum } from 'lib/array/arrayUtils'
import { checkoutAccommodationOfferView } from '../view/accommodation'
import { floatify } from 'lib/maths/mathUtils'

export const getAccommodationTotals = createSelector(
  (state: App.State) => checkoutAccommodationOfferView(state),
  (offerViewsWithStatus): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const result = offerViewsWithStatus.data.map(view => computeAccommodationOfferTotalsView(view, { checkoutWithMemberPrice: false, hasLuxPlusOrSubscriptionInCart: false, isPostPurchaseTourDateChange: false }))
    return {
      hasRequiredData: offerViewsWithStatus.hasRequiredData,
      data: addTotals(result).data,
    }
  },
)

export const getAccommodationTotal = createSelector(
  (state: App.State) => getAccommodationTotals(state),
  (totals): number => {
    const { price = 0, surcharge = 0, otherFees = {} } = totals.data
    return price + surcharge + sum(Object.values(otherFees))
  },
)

export const getDueAtProperty = createSelector(
  (state: App.State) => getAccommodationTotals(state),
  (totals): number => (totals.data.otherFees?.propertyFees || 0) + (totals.data.otherFees?.extraGuestSurcharge || 0),
)

export const getAccommodationPayable = createSelector(
  (state: App.State) => getAccommodationTotals(state),
  (state: App.State) => getDueAtProperty(state),
  (accommodationTotal, dueAtProperty): number => {
    const { price = 0, surcharge = 0, otherFees = {} } = accommodationTotal.data
    return floatify(price + surcharge + sum(Object.values(otherFees)) - dueAtProperty)
  },
)

export const selectEarnableAccommodationBusinessTravellerCreditsTotal = createSelector(
  (state: App.State) => checkoutAccommodationOfferView(state),
  (
    offerViewsWithStatus,
  ): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    let price = 0
    for (const offerView of offerViewsWithStatus.data) {
      for (const itemView of offerView.itemViews) {
        price += itemView.totals.businessTravellerCredits ?? 0
      }
    }

    return {
      hasRequiredData: offerViewsWithStatus.hasRequiredData,
      data: {
        price,
        memberPrice: 0,
        taxesAndFees: 0,
        value: 0,
        memberValue: 0,
        surcharge: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)
